import React, {useState, useEffect} from "react";
// reactstrap components
import { Card, CardHeader, CardBody, Row, Col, CardImg, Button, Modal, ModalBody, ModalHeader, FormGroup, Input, ModalFooter, Progress, Label,Form, CardText} from "reactstrap";
import { getAllTickets } from "network/ApiAxiosEventsGetickets";

const EventCards = (props) => {
  const [modal, setModal] = useState(false);
  const [roleCheck, setroleCheck] = useState("");
  const [QT, setQT] = useState("");
  const [bottle, setbottle] = useState("Standard Spirit (E.g. Eristoff, Bacardi, Malibu, Gin, Cap. Morgan Spiced, Whiskey)");
  const [selectedEventDate, setSelectedEventDate] = useState('');
  const [selectedEventTickets, setSelectedEventTickets] = useState([]);
  const [bottleExtra, setbottleExtra] = useState(bottle.includes('Standard') ? 0 : bottle.includes('Premmium') ? 50 : 100);
  const [qtSelector, setQtSelector] = useState('');
  
  const role = JSON.parse(localStorage.getItem("user")).role;

  const toggle = () => setModal(!modal);

  useEffect(() => {
    checkRole()
  }, []);

  useEffect(() => {
    fetchEventTickets()
  }, [selectedEventDate]);

  const fetchEventTickets = async()=>{
    if(selectedEventDate){
      const resp = await getAllTickets(selectedEventDate,'EU')
      if(resp.data.success){
        console.log('tickets f this event----',resp.data.tickets)
        if(role == 'reseller'){
          //const discountPercentage = JSON.parse(localStorage.getItem("user")).discountPercentage
          setSelectedEventTickets(resp.data.tickets.map((ticketItem)=>{
            return{
              ...ticketItem,
              price: ticketItem.reseller
            }
          }))
        }else{
          setSelectedEventTickets(resp.data.tickets.map((ticketItem)=>{
            return{
              ...ticketItem,
              price: ticketItem.seller
            }
          }))
        }
      }
    }
  }
 
  const checkRole = ()=>{
    //console.log(props)
    if(role === "admin" || role === "seller" || role === "shop"){
      setroleCheck(true)
    }else{
      setroleCheck(false)
    }
  }

  const addToCart =(event,vipData)=>{
    console.log('llllll---',event,vipData)
    if(event.stock < QT){
      alert('Not enough stock')
      setQT(0)
      toggle()
    }else{console.log('event-----',event)
    let cartItem = { 
      ...event, 
      name: vipData ? event.name + ' ' + vipData.name + ' ' + props.event.name + ' ' + props.event.venue + ' ' + event.checkinFrom.split('T')[0] : event.name + ' ' + props.event.name + ' ' + props.event.venue + ' ' + event.checkinFrom.split('T')[0]  ,
      qt: vipData ? 1 : QT, 
      bottle: vipData ? bottle : '',  
      posterImage : props.event.posterImage,
      mainEventId : props.event._id,
      price: vipData ? vipData.name.includes('Gold') ? parseInt(event.sellerGold) + parseInt(bottleExtra) : parseInt(event.sellerDiamond) + parseInt(bottleExtra) : event.price,
      vipType: vipData ? vipData.name.includes('Gold') ? 'Gold' : 'Diamond' : '',
      tableNumber: vipData ? vipData.tableNumber : '',
    }
    if(!localStorage.getItem("cart")){
      localStorage.setItem("cart", JSON.stringify([cartItem]));
      setQT("")
      props.updateCartQT()
    }else{
      let cartArray = JSON.parse(localStorage.getItem("cart"))
      const checkExists = cartArray.findIndex(element => element._id == event._id)
      if(checkExists == -1){
        cartArray.push(cartItem)
        setQT("")
        props.updateCartQT()
      }else{
        if(parseInt(cartArray[checkExists].qt) + parseInt(vipData ? 1 : QT) > event.stock){
          alert("Not enough tickets left. Too many in the cart already")
        }else{
          vipData ? cartArray.push(cartItem) :
          cartArray[checkExists].qt = parseInt(cartArray[checkExists].qt) + parseInt(vipData ? 1 : QT)
          setQT("")
          props.updateCartQT()
        }
      }
      localStorage.setItem("cart", JSON.stringify(cartArray))
    }
    toggle()}
  }

  const bottleHandler = (e)=>{
    console.log(e.target)
    var index = e.target.selectedIndex;
    setbottle(e.target.options[index].label)
    setbottleExtra(e.target.options[index].value)
    //props.event.Price = e.target.value
  }

  const handleTableDisplay = (ticketData)=>{
    const availableTables = ticketData.tables.filter((tableItem) => tableItem.available && tableItem.name != 'Silver')
    const availableSilverTables = ticketData.tables.filter((tableItem) => tableItem.available && tableItem.name == 'Silver').length
    const availableGoldTables = ticketData.tables.filter((tableItem) => tableItem.available && tableItem.name == 'Gold').length
    const availableDiamondTables = ticketData.tables.filter((tableItem) => tableItem.available && tableItem.name == 'Diamond').length
    const uniqueData = availableTables.reduce((acc, obj) => {
      if (!acc.some(item => item.name === obj.name)) {
          acc.push(obj);
      }
      return acc;
    }, []);
    
    return uniqueData.length > 0 && uniqueData.map((tableUniqueItem,tableIndex)=>{
      return<Col key={tableUniqueItem._id + tableIndex} className="w-100"> 
        <Row className="mb-3">
          <Col sm={8} xs={8} md={8}>
            <Row>
              <CardText>Ticket:{tableUniqueItem.name} Table</CardText>
            </Row>
            <Row>{console.log('vip---',selectedEventTickets.find((item)=> item.isVIP))}
              <CardText>Price:{parseInt(tableUniqueItem.name.includes('Gold') ? selectedEventTickets.find((item)=> item.isVIP).sellerGold : selectedEventTickets.find((item)=> item.isVIP).sellerDiamond) + parseInt(bottleExtra)}</CardText>
            </Row>
            <Row>
              <CardText>Tickets Left:{tableUniqueItem.name == 'Gold' && availableGoldTables}{tableUniqueItem.name == 'Diamond' && availableDiamondTables}</CardText>
            </Row>
            <Row className=" d-none">
              <label className="mr-2">Deposit:</label>
            </Row>
          </Col>
          <Col sm={4} xs={4} md={4} >
              <Col >
                {
                tableUniqueItem.name.includes("Gold") &&
                <Input type="select" onChange={(e)=>bottleHandler(e)} style={{width:'120%'}}>  
                    <option key="1" value={0} label="Standard Spirit (E.g. Eristoff, Bacardi, Malibu, Gin, Cap. Morgan Spiced, Whiskey)" >Standard Spirit (E.g. Eristoff, Bacardi, Malibu, Gin, Cap. Morgan Spiced, Whiskey)</option>
                    <option key="5" value={0} label="Premium Spirit (E.g. Grey Goose, Ciroc, Jack Daniels, Courvoisier, Disaronno, Bacardi Razz )" >Premium Spirit (E.g. Grey Goose, Ciroc, Jack Daniels, Courvoisier, Disaronno, Bacardi Razz )</option>
                    <option key="10" value={50} label="Top Shelf Spirit (E.g. Belvedere, Hennessy, Moet Chandon, Black Label)" >Top Shelf Spirit (E.g. Belvedere, Hennessy, Moet Chandon, Black Label)</option>                        
                </Input>
                }
                {
                tableUniqueItem.name.includes("Diamond") &&
                <Input type="select" onChange={(e)=>bottleHandler(e)} style={{width:'120%'}}>                          
                    <option key="1" value={0} label="Standard Spirit (E.g. Eristoff, Bacardi, Malibu, Gin, Cap. Morgan Spiced, Whiskey)" >Standard Spirit (E.g. Eristoff, Bacardi, Malibu, Gin, Cap. Morgan Spiced, Whiskey)</option>
                    <option key="5" value={0} label="Premium Spirit (E.g. Grey Goose, Ciroc, Jack Daniels, Courvoisier, Disaronno, Bacardi Razz )" >Premium Spirit (E.g. Grey Goose, Ciroc, Jack Daniels, Courvoisier, Disaronno, Bacardi Razz )</option>
                    <option key="10" value={0} label="Top Shelf Spirit (E.g. Belvedere, Hennessy, Moet Chandon, Black Label)" >Top Shelf Spirit (E.g. Belvedere, Hennessy, Moet Chandon, Black Label)</option>  
                </Input>
                }
              </Col>
            <Button onClick={()=> addToCart(ticketData,tableUniqueItem)}>Add to cart</Button>
          </Col>
        </Row>
      </Col>
    })
  }

   
    return (
          <>
              <Card className="shadow" style={{ width: '18rem'}}>
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <Col xs="6">
                      <h3 className="mb-0" >{props.event.name} </h3>
                      <h5 className="mt-2" >{props.event.venue} </h5>
                    </Col>
                    <Col className="text-right" xs="6">
                      <CardImg
                        style={{borderRadius: "150px"}}
                        alt="Card image cap"
                        src={'https://new.geticketsonline.com/files/product-images/' + props.event.posterImage}
                        top
                        width="3%"
                      />
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody className="align-self-center"  >
                  {
                    props.event.eventDates.map((eventDateItem)=>{
                      return <div key={eventDateItem._id} style={{cursor:'pointer'}} onClick={()=>{
                        setSelectedEventDate(eventDateItem._id)
                        toggle()
                      }} ><Row className="border border-2 mb-1 border-default">
                        <label className="mr-2">Date:</label>
                        {eventDateItem.timeStart.split("T")[0]}
                        <label className="mr-2 ml-4">Time:</label>
                        {eventDateItem.timeStart.slice(11,16)}
                        </Row>
                        <Row hidden>
                          <label className="mr-2">Venue:</label>
                          {eventDateItem.venue}
                        </Row>
                        <Row hidden>
                          <label className="mr-2">Djs:</label>
                          {eventDateItem.artists}
                        </Row>
                      </div>
                    })
                  }
                </CardBody>
              </Card>

              <Modal isOpen={modal} toggle={toggle} >
                <ModalHeader toggle={toggle}>{selectedEventTickets.length > 0 && selectedEventTickets[0].checkinFrom.split('T')[0]}</ModalHeader>
                <ModalBody>
                  {selectedEventTickets.length > 0 && selectedEventTickets.map((ticketItem)=>{
                    console.log('event tickets----',selectedEventTickets)
                    return !ticketItem.name.includes('Early') && !ticketItem.name.includes('VIP') && ticketItem.stock > 0 ?  <Col key={ticketItem._id} className="w-100"> 
                      <Row className="mb-3">
                        <Col sm={8} xs={8} md={8}>
                          <Row>
                            <CardText>Ticket:{ticketItem.name}</CardText>
                          </Row>
                          <Row>
                            <CardText>Price:{ticketItem.price} €</CardText>
                          </Row>
                          <Row>
                            <CardText>Tickets Left:{ticketItem.stock}</CardText>
                          </Row>
                          <Row className=" d-none">
                            <label className="mr-2">Deposit:</label>
                          </Row>
                        </Col>
                        <Col sm={4} xs={4} md={4} >
                        {console.log('pppppppd----',ticketItem.stock)}
                          <Input id="qt" type="number" max={ticketItem.stock} value={qtSelector == ticketItem._id ? QT : 0} placeholder="Qt." onChange={e=>{
                                setQT(e.target.value), setQtSelector(ticketItem._id)}} />
                          <Button onClick={()=> addToCart(ticketItem)} >Add to cart</Button>
                        </Col>
                      </Row>
                    </Col>
                    :
                    ticketItem.name.includes('VIP') && <Col key={ticketItem._id} className="w-100"> 
                      {handleTableDisplay(ticketItem)}
                    </Col>
                  })}
                </ModalBody>
              </Modal>
          </>
                );
            }
            
    export default EventCards;